import {
  DRIVER_FILES_ACTIONS,
  ROUTES,
  TABLE_NAMES
} from "../../../../../shared";
import { useReleaseFeatureToggle } from "../../../../../shared/featureToggles/hooks";
import { FEATURE_NAMES } from "../../../../../shared/featureToggles/types";
import DownloadDialog from "../../dialogs/reusableDialogs/DownloadDialog/DownloadDialog";
import { useDialog } from "../../hooks/useDialog";
import PageHeaderActions from "../PageHeaderActions";

const DriversFilesPageHeaderActions = () => {
  const { isDialogOpen, openDialog, closeDialog } = useDialog();
  const { isReleaseFeatureEnabled } = useReleaseFeatureToggle();

  const filesTableName = TABLE_NAMES.Drivers;
  const showDriverFileSettings = isReleaseFeatureEnabled(
    FEATURE_NAMES.ShowFileSettingsButton
  );

  return (
    <PageHeaderActions
      route={ROUTES.DriverFiles}
      openDialog={openDialog}
      download
      fileSettings={showDriverFileSettings}
    >
      <DownloadDialog
        route={ROUTES.DriverFiles}
        isOpen={isDialogOpen[DRIVER_FILES_ACTIONS.Download]}
        onClose={closeDialog}
        filesTableName={filesTableName}
      />
    </PageHeaderActions>
  );
};

export default DriversFilesPageHeaderActions;
